<script lang="ts">
    import tagIcon from "../../assets/tag.svg?raw";
    import xIcon from "../../assets/x.svg?raw";

    export let tag: string;
    export let closePressedCallback: () => void;
</script>

<div
    class="searchbar-pill border-solid-2px border-blue border-radius-pico-border-radius padding-left-5px"
>
    <p class="font-size-0-7rem height-1rem width-max-content margin-bottom-0">
            {tag}
        </p>
    <div class="width-0-5rem" on:click={closePressedCallback}>
        {@html xIcon}
    </div>
</div>
